exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-wrapper[data-v-b9057642]{display:flex;align-items:center;gap:12px;flex-wrap:wrap}.signed-filter[data-v-b9057642]{display:inline-flex;align-items:center;gap:10px;margin-left:12px;align-self:center}.signed-filter__label[data-v-b9057642]{color:#606266;font-size:14px;white-space:nowrap}.signed-filter__radios>>>.el-radio[data-v-b9057642]{margin-right:12px}.signed-filter__radios>>>.el-radio[data-v-b9057642]:last-child{margin-right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-b9057642&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/UniversityManage/UniversityManage/CollegeManage/CollegeManage.vue
// module id = 619
// module chunks = 0